import React from 'react';
import BorrowablesDetails from '../BorrowablesDetails';
import AccountLendingPool from '../AccountLendingPool';
import NotSynced from '../NotSynced';
import { NOT_SYNCED } from 'impermax-sdk';
import { useGetBlacklisted } from '../../hooks/useNetwork';
import useFactory from '../../hooks/useFactory';
import usePairAddress from '../../hooks/usePairAddress';

export default function LendingPoolPage() {
  //const oracleIsInitialized = useOracleIsInitialized();
  //if (!oracleIsInitialized) return (<div className="info">
  //  <b>Info</b>: This lending pool has just been created and the TWAP price oracle is not ready yet. Every time a new pair is created on Impermax it cannot be used for 30 minutes in order to gather enough price history.
  //</div>);
  const factory = useFactory();
  const pairAddress = usePairAddress();
  const getBlacklisted = useGetBlacklisted();

  return (<>
    {
      getBlacklisted(factory).includes(pairAddress) && (
        <div className="warning">
          <b>Warning</b>: This lending pool has been blacklisted. If you have assets deposited in this pool please withdraw them as soon as possible.
        </div>
      )
    }
    { 
      NOT_SYNCED ? (
        <NotSynced />
      ) : (<>
        <BorrowablesDetails />
      </>)
    }
    <AccountLendingPool />
  </>);
}